import axiosInstance from "@/utils/axios";
import API from "@/constant/API";

const disableAccount = async (data) => {
  return await axiosInstance.post(API.ACCOUNT_DISABLE, data);
}

const enableAccount = async (data) => {
  return await axiosInstance.post(API.ACCOUNT_ENABLE, data);
}

// auth bind.
const fetchGoogleCode = async () => {
  return await axiosInstance.post(API.GA_KEY_FETCH);
}

const bindGoogle = async (data) => {
  return await axiosInstance.post(API.GA_BIND, data);
}

const unbindGoogle = async (data) => {
  return await axiosInstance.post(API.GA_UNBIND, data);
}

const bindMobileExist = async (data) => {
  return await axiosInstance.post(API.BIND_MOBILE_EXIST, data);
}

const bindMobile = async (data) => {
  return await axiosInstance.post(API.MOBILE_BIND, data);
}

const unbindMobile = async (data) => {
  return await axiosInstance.post(API.MOBILE_UNBIND, data);
}

const bindEmailExist = async (data) => {
  return await axiosInstance.post(API.BIND_EMAIL_EXIST, data);
}

const bindEmail = async (data) => {
  return await axiosInstance.post(API.EMAIL_BIND, data);
}

const unbindEmail = async (data) => {
  return await axiosInstance.post(API.EMAIL_UNBIND, data);
}

// auth update.
const updateMobileVerify = async (data) => {
  return await axiosInstance.post(API.MOBILE_UPDATE_VERIFY, data);
}

const updateMobile = async (data) => {
  return await axiosInstance.post(API.MOBILE_UPDATE, data);
}

const updateEmailVerify = async (data) => {
  return await axiosInstance.post(API.EMAIL_UPDATE_VERIFY, data);
}

const updateEmail = async (data) => {
  return await axiosInstance.post(API.EMAIL_UPDATE, data);
}

// 获取待确认的3ds请求
const list3ds = async () => {
  return await axiosInstance.post(API.GET_PENDING_3DS);
}
const approve3ds = async (data) => {
  return await axiosInstance.post(API.APPROVE_3DS, data);
}

/*
'action'
'deviceId' 
'params'
'expand'
*/
const init2FAVerify = async (data) => {
  return await axiosInstance.post(API.AUTH_GET_RULE, data);
}
const verify2FAOption = async (data) => {
  return await axiosInstance.post(API.AUTH_VERIFY_OPTION, data);
}

const findPwExist = async (data) => {
  return await axiosInstance.post(API.FIND_PW_EXIST, data);
}
const findPwReset = async (data) => {
  return await axiosInstance.post(API.FIND_PW_RESET, data);
}

const liveDetect = async () => {
  return await axiosInstance.post(API.LIVE_DETECT);
}

const getIntercomHmnac = async () => {
  return await axiosInstance.post(API.GET_INTERCOM_HMAC);
}

export {
  init2FAVerify,
  verify2FAOption,
  findPwExist,
  findPwReset,

  disableAccount,
  enableAccount,
  fetchGoogleCode,
  bindGoogle,
  unbindGoogle,
  bindMobileExist,
  bindMobile,
  unbindMobile,
  bindEmailExist,
  bindEmail,
  unbindEmail,
  updateMobileVerify,
  updateMobile,
  updateEmailVerify,
  updateEmail,
  list3ds,
  approve3ds,

  liveDetect,
  getIntercomHmnac,
};
